import "./style.scss";
import { useEffect, useState } from "react";
import SectionHeader from "@components/SectionHeader";
import { useNavigate } from "react-router";
import "react-range-slider-input/dist/style.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { Link } from "react-router-dom";
import Button from "@components/Button";
import HeroDesktop from "./img/hero-desktop.png";
import HeroMobile from "./img/hero-mobile.jpg";
import image01 from "./img/01.png";
import image02 from "./img/02.png";
import image03 from "./img/03.png";
import shop from "./img/shop.svg";
import user from "./img/user.svg";
import register from "./img/register.svg";
import news from "./img/news.svg";
import stories from "./img/stories.svg";
import gift from "./img/gift.svg";
import qrcode from "./img/qrcode.svg";
import TutorialImg from "./img/tutorialimg.png";
import {
  DETAILS_CACHE_TIME,
  DETAILS_REFETCH_INVERVAL,
  DETAILS_STALE_TIME,
  getUserDetails,
} from "@api/consumer";
import "./style.scss";
import StatusSwiper from "../../../components/StatusSwiper";
import { useQuery } from "@tanstack/react-query";
import { EasterEgg } from "@pages/EasterEggPage";
import DOMPurify from "dompurify";

const cardsInfo = [
  {
    title: "Sammle<br/>  Punkte",
    desc: "für alle Aktivitäten und erhöhe deinen Status.",
    cardImg: image01,
  },
  {
    title: "Sammle<br/>  Gutscheine",
    desc: "und profitiere von vielen Angeboten und spare bei deinen Lieblingsprodukten.",
    cardImg: image02,
  },
  {
    title: `Empfehle <br/> Inspiration Club<br/>`,
    desc: "sende Rabattcodes an Freunde und sammle Prämien",
    cardImg: image03,
  },
];

const featuresContent = [
  {
    title: "Aktivitäten",
    desc: "<strong>20 Punkte -</strong> für jede abgeschlossene Aktivität",
    icon: shop,
    link: "/activities",
  },
  {
    title: "Empfehle es einem Freund",
    desc: "<strong>100 Punkte </strong> - für eine erfolgreiche Weiterempfehlung des glo™ oder Vuse Geräts",
    icon: user,
    link: "/invite",
  },
  {
    title: "glo™ Registrierung",
    desc: "<strong>50  Punkte</strong> - für jedes registrierte glo™ Gerät",
    icon: register,
  },
  {
    title: "Vuse Umfrage",
    desc: "QR-Code scannen, Umfrage<br/> ausfüllen, Punkte erhalten <span>*Nur für Vuse Pods verfügbar.</span>",
    icon: qrcode,
  },
  {
    title: "Inspiration Stories",
    desc: "<strong>5 Punkte </strong> - für jede angesehene Gruppe von Stories",
    icon: stories,
    link: "/",
  },
  {
    title: "Geburtstagsgeschenk",
    desc: "<strong>50 Punkte </strong> - zum Geburtstag",
    icon: gift,
  },
];

export default function Essentials() {
  const navigate = useNavigate();
  const [activeStatus, setActiveStatus] = useState(0);

  const { data } = useQuery({
    queryKey: ["user-details"],
    queryFn: getUserDetails,
    refetchInterval: DETAILS_REFETCH_INVERVAL,
    staleTime: DETAILS_STALE_TIME,
    cacheTime: DETAILS_CACHE_TIME,
  });

  useEffect(() => {
    setActiveStatus(data?.consumer.level);
  }, [data]);

  return (
    <div className="about-page-content">
      <div className="page-grid">
        <div className="hero">
          <div className="image-wrapper">
            <picture>
              <source media="(min-width: 720px)" srcSet={HeroDesktop} />
              <img
                className="img"
                src={HeroMobile}
                alt={"Urządzenia i paczki neo/veo"}
              />
            </picture>
          </div>
          <div className="inner">
            <p className="desc">
              <strong>
                Willkommen im
                <br /> Inspiration Club
              </strong>{" "}
              - einem
              <br />
              Ort für Nutzer von{" "}
              <strong>
                glo™,
                <br /> Vuse
              </strong>{" "}
              und mehr.
            </p>
          </div>
        </div>

        <div className="key-info">
          <SectionHeader>
            <strong>Wesentliche Elemente</strong>
          </SectionHeader>
          <div className="cards">
            {cardsInfo.map((card, i) => (
              <div key={card.title} className="card">
                <div className="card-img">
                  <img src={card.cardImg} alt={card.title} />
                </div>
                <div className="body">
                  <div className="header">
                    <div className="counter">{i + 1}</div>
                    <div
                      className="title"
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(card.title),
                      }}
                    ></div>
                  </div>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(card.desc),
                    }}
                    className="desc"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="features">
          <SectionHeader>
            <strong>Sammle Punkte so,</strong> wie du es willst
          </SectionHeader>
          {/* <EasterEgg ident={"halloween2025_2"} direction="right" /> */}
          <div className="cards">
            {featuresContent.map((item, index) => (
              <div
                key={item.title}
                className={`card ${item.link ? "" : "non-link"}`}
              >
                {item.link ? (
                  <div className="header">
                    <Link to={item.link}>
                      <img src={item.icon} alt="icon" />
                      <div className="title-wrapper">
                        <h2
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(item.title),
                          }}
                        />
                        <p
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(item.badge),
                          }}
                        ></p>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(item.desc),
                          }}
                          className="desc"
                        />
                      </div>
                    </Link>
                  </div>
                ) : (
                  <div className={`header `}>
                    <div className={`non-link c${index}`}>
                      <img src={item.icon} alt="icon" />
                      <div className="title-wrapper">
                        <h2
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(item.title),
                          }}
                        />
                        <p
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(item.badge),
                          }}
                        ></p>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(item.desc),
                          }}
                          className="desc"
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
          <div className="status">
            <SectionHeader>
              <strong>Vorteile </strong> eines höheren Status
            </SectionHeader>
            <StatusSwiper activeStatus={activeStatus} />
          </div>
          <div className="tutorial">
            <SectionHeader>
              Starte das&nbsp;
              <strong>
                Inspiration <br />
                Club&nbsp;
              </strong>
              Tutorial erneut
            </SectionHeader>
            <div className="cta">
              <Button action={() => navigate("/?tutorial=true")}>
                Erneut beginnen
              </Button>
            </div>
            <img className="tutorial-img" alt="TutorialImg" src={TutorialImg} />
          </div>
        </div>
      </div>
    </div>
  );
}
